import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import {WithStyles} from "@material-ui/core/styles/withStyles";
import * as React from "react";

type ClassNames = "container";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
  container: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.up("xs")]: {
      width: "auto"
    },
    [theme.breakpoints.up("sm")]: {
      width: "540px"
    },
    [theme.breakpoints.up("md")]: {
      width: "720px"
    },
    [theme.breakpoints.up("lg")]: {
      width: "960px"
    },
    [theme.breakpoints.up("xl")]: {
      width: "1140px"
    }
  }
});

interface IContainerProps extends WithStyles<typeof styles>  {
  children: React.ReactNode
}

class Container extends React.PureComponent<IContainerProps> {

  public render() {
    const {classes, children} = this.props;
    return (
      <div className={classes.container}>
      {children}
      </div>
    );
  }
}

export default withStyles(styles)(Container);


// WEBPACK FOOTER //
// ./src/components/Container.tsx